// src/components/Terms.jsx
import React from 'react';

export default function TermsOfService() {
    // Modal logic (useEffect) removed so the page scrolls normally.

    return (
        <div style={styles.contentWrapper}>
            <h1 style={styles.mainTitle}>Terms of Service</h1>
            <p style={{ color: '#666' }}>Last updated: April 08, 2026</p>
            
            <div style={styles.textContent}>
                {/* Section 1 */}
                <div style={styles.section}>
                    <strong style={styles.heading}>1. Acceptance of Terms</strong>
                    <p>By accessing or using Shepherd ("the Service"), including our website and Chrome Extension, you agree to be bound by these Terms of Service. If you do not agree to these terms, you may not access or use the Service.</p>
                </div>

                {/* Section 2 */}
                <div style={styles.section}>
                    <strong style={styles.heading}>2. Description of Service</strong>
                    <p>Shepherd provides software tools to create, manage, and share AI-generated guided tours for web applications. We use advanced anchoring methods—including text, selectors, and ARIA proximity—to provide these services.</p>
                </div>

                {/* Section 3 */}
                <div style={styles.section}>
                    <strong style={styles.heading}>3. User Accounts & Subscriptions</strong>
                    <p>
                        <strong>Account Responsibility:</strong> You are responsible for maintaining the security of your account and any activity that occurs under it.<br /><br />
                        <strong>Subscription Fees:</strong> Access to certain features requires a paid subscription (currently $19/month). Payments are processed via Stripe.<br /><br />
                        <strong>Cancellations:</strong> You may cancel your subscription at any time. No refunds are provided for partial billing periods.
                    </p>
                </div>

                {/* Section 4 */}
                <div style={styles.section}>
                    <strong style={styles.heading}>4. Intellectual Property</strong>
                    <p>
                        <strong>Our Property:</strong> The "Shepherd" name, logo, Chrome Extension source code, and AI anchoring logic are the exclusive property of Luke Mancuso.
                    </p>
                </div>

                {/* Section 7 */}
                <div style={styles.section}>
                    <strong style={styles.heading}>7. Limitation of Liability</strong>
                    <p>Shepherd is provided on an "as-is" basis. We are not liable for any damages resulting from errors in AI-generated element anchoring or changes to third-party website code.</p>
                </div>

                {/* Section 9 */}
                <div style={styles.section}>
                    <strong style={styles.heading}>9. Contact Us</strong>
                    <p>Questions about the Terms of Service should be sent to:<br />
                    <strong>Email: <a href="mailto:luke@startshepherd.com">luke@startshepherd.com</a></strong></p>
                </div>
            </div>
        </div>
    );
}

const styles = {
    contentWrapper: {
        color: "black",
        textAlign: "left",
    },
    textContent: {
        marginTop: "1.5rem",
    },
    mainTitle: {
        fontSize: "2rem",
        marginBottom: "0.5rem",
        marginTop: 0,
        color: '#1a73e8'
    },
    section: {
        marginBottom: "2rem",
        lineHeight: "1.6",
        color: "#333"
    },
    heading: {
        display: "block",
        marginBottom: "0.5rem",
        fontSize: "1.2rem",
        color: "#000"
    },
};
